import { ExportColumn } from '../types';

export const resolveSelectedColumnNames = (columns: ExportColumn[]): string[] =>
  columns.filter((column) => column.selected).map((column) => column.name);
